import { ANYCOMPASS_PARENT_ORIGINS } from '../constants/embed'

// 「今 iframe に埋め込まれて動いているか」の同期判定。認証系のゲートはこれを使う。
//
// EmbedContext の isEmbedded とは別物。あちらは READY→INIT ハンドシェイクで親 origin を
// pin できたか (= 転記 APPLY_SOAP の送信先が決まったか) を表すもので、確定まで最大 6 秒
// かかるうえ、INIT が来なければ永久に false のままになる。認証は iframe 起動と同じ秒に
// 走るのでその窓を素通りしてしまう。混同しないこと (log/188 work-log/6 §3)。
//
// ANYCOMPASS_PARENT_ORIGINS が空 = 埋め込み用 env を持たないビルド (legacy 配信)。
// self !== top だけだと legacy 配信が iframe に置かれたときにも true になるため AND で落とす。
export const isEmbeddedContext = (): boolean =>
  ANYCOMPASS_PARENT_ORIGINS.length > 0 && window.self !== window.top
